module.exports = __webpack_public_path__ + "static/media/commercial.cb1c583c.png";